import { Div, Span, UnorderedList } from "@tblabs/truffle";
import { Order } from "../../../../Models/Order";
import { RawDiscount } from "../../../../Models/Ticket";

export enum DiscountType
{
    Percent = "percent",
    LimitedPercent = "limited-percent",
    FixedPrice = "fixed-price",
}

export class DiscountsList extends Div
{
    constructor(order: Order)
    {
        super("");

        const discounts = order.Meta?.Ticket?.BasketInfo?.Discounts;

        if (discounts?.length === 0)
        {
            this.Append("Brak zniżek");
            return;
        }
        
        this.Append(
            `Ilość zniżek: ${discounts?.length || 0}`,
            new UnorderedList(discounts?.map(x => this.DiscountToString(x))).MarginTop(8)
        );
    }

    private DiscountToString(discount: RawDiscount): string
    {
        if (discount.Type === DiscountType.Percent)
            return `${discount.Code}: ${discount.Name}: -${discount.Value}%`;
        else if (discount.Type === DiscountType.LimitedPercent)
            return `${discount.Code}: ${discount.Name}: -${discount.Value}% (limit: ${discount.Limit} zł)`;
        else if (discount.Type === DiscountType.FixedPrice)
            return `${discount.Code}: ${discount.Name}: -${discount.Value} zł`;
        return `discount type not supported: ${discount.Type} (code: ${discount.Code}, name: ${discount.Name}, value:${discount.Value}, limit: ${discount.Limit})`;
    }
}
